import getConfig from 'next/config';

import withMediaPlayerUrl from '../../helpers/withMediaPlayerUrl';

const { publicRuntimeConfig } = getConfig();

const MediaPlayerEmbed = withMediaPlayerUrl(publicRuntimeConfig.player.domain);

export default MediaPlayerEmbed;
